import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const getFilteredInvoiceList = (payload) => AxiosClient.get(`/invoice-list?filter_type=${payload}`);
const searchFreightCharge = () => AxiosClient.get(`/freight-list`);

const addFreightCharge = payload => AxiosClient.post('/freight-charge', payload);

export {
    searchFreightCharge,
    getFilteredInvoiceList,
    addFreightCharge
}